export const RANGO_FLUJO_OPERACION_OPERADOR_LOGICO_ENUM = {
  EQ: 0,
  GT: 1,
  LT: 2,
  GE: 3,
  LE: 4,
  ENTRE: 5,
} as const

export const OPERADOR_RANGO_FLUJO_OPERACION = {
  0: "=",
  1: ">",
  2: "<",
  3: ">=",
  4: "<=",
  5: "entre",
} as const

export type RangoFlujoOperacionOperadorLogicoEnumType =
  (typeof RANGO_FLUJO_OPERACION_OPERADOR_LOGICO_ENUM)[keyof typeof RANGO_FLUJO_OPERACION_OPERADOR_LOGICO_ENUM]
